@import '~style-sheet-helpers/core.less';
@import '../../../../app-brand/entities/entity-layer.module.less';

.menu-label {
  margin: 0;
  margin-bottom: 12px;
  color: @settings-page--shipping-packages-carrier-label--text-color;
  font-size: 14px;
}
.menu-toggler {
  min-width: 178px;
}
